<template>
  <h-form autocomplete="off" :model="loginForm" ref="loginForm" label-position="left" class="card-box login-form" :label-width="56"
    style="width:300px;margin-left:10px;">
    <div class="login-form-wrapper">
      <h-form-item label="手机号" prop="username" :class="{'userFocus':userFocusStatus}">
        <h-input name="username" :type="setas" v-model="loginForm.username" :placeholder="$t('m.i.common.login_username')"
          @on-focus="handlefocus('user')" @on-blur="handleblur('user')" @on-change="handleChange('user')" @on-enter="handleEnter('user')"
          ref='username'>
        </h-input>
        <div class="inputimg">
          <img src="../../assets/jt.png" :class="hasClass==='1' ? 'openlist': (hasClass==='0'?'foldlist':'')"
            @click="showAccountList($event)" />
        </div>
        <ul v-show="isShowUserList" ref='loginUl'>
          <li :class="{'selected':item.selected === true}" v-for="item in userList" :key="item" @click="changeUser(item)">
            <span>{{item.user}}</span>
            <img src="" alt="" @click="deleteUser(item.user)">
          </li>
        </ul>
        <div class="verify-tip verify-bottom" v-show='userError'>
          <div class="verify-tip-arrow"></div>
          <div class="verify-tip-inner">{{userErrorInfo}}</div>
        </div>
      </h-form-item>
      <h-form-item label="验证码" prop="checkcode" :class="{'checkFocus':checkFocusStatus}">
        <h-input @on-enter="handleLogin" name="checkcode" type="text" :specialFilter="true" :specialLength="6" :specialDecimal="0" v-model="loginForm.checkcode" autocomplete="off"
          :placeholder="$t('m.i.common.checkcodeInfo')" ref='check2'>
        </h-input>
        <div class="checkcode">
          <a href="javascript:void(0)" @click="createCode" :class="{'has-send-code':codeTimer}">{{secondsText}}</a>
        </div>
        <div class="verify-tip verify-bottom" v-show='codeError'>
          <div class="verify-tip-arrow"></div>
          <div class="verify-tip-inner">{{codeErrorInfo}}</div>
        </div>
      </h-form-item>
    </div>
    <div class="form-item-set" style="-webkit-app-region: no-drag;">
      <h-form-item>
        <input type="checkbox" value="reading" :checked="remUser" @change='remember'><span>记住账号</span>
        <input type="checkbox" value="tourist" :checked="proUser" @change='protect' style="margin-left: 20px;"><span>保护账号</span>
      </h-form-item>
    </div>
    <div class="form-item-submit" style="-webkit-app-region: no-drag;margin:-19px 0 0 40px;z-index:1;">
      <h-form-item style="margin-bottom: 0">
        <h-button type="primary" style="width:120px;height:33px;" :loading="loading" @click.native.prevent="handleLogin" ref="submit">
          <span v-if="!loading">{{$t('m.i.common.login')}}</span>
          <span v-else>加载中...</span>
        </h-button>
      </h-form-item>
    </div>
  </h-form>
</template>
<script>
import { sendPhoneCode } from '@frame/api/login'
let phoneReg = /^1[0-9]{10}$/
export default {
  name: 'webCellPhoneLogin',
  data () {
    return {
      loginForm: {
        username: '',
        checkcode: ''
      },
      userError: false,
      userErrorInfo: '',
      codeError: false,
      codeErrorInfo: '',
      userFocusStatus: false,
      checkFocusStatus: false,
      codeTimer: null,
      secondsText: '获取验证码',
      codeCount: 60,
      loading: false,
      isShowUserList: false,
      remUser: false,
      proUser: false,
      userList: [],
      hasClass: '0',
      deleteUserState: false,
      cityList: [
        {
          value: 'beijing',
          label: '行情主站1'
        },
        {
          value: 'shanghai',
          label: '行情主站2'
        }
      ],
    }
  },
  watch: {
    'loginForm.checkcode': {
      handler: function () {
        this.codeError = false
      },
      deep: true
    },
    'loginForm.username': {
      handler: function () {
        this.userError = false
      },
      deep: true
    }
  },
  mounted () {
    this.getUserInfo()

    // 监听刷新事件
    this.$myIpcSend.renderer().on('refresh', event => {
      this.loginForm.username = ''
      this.loginForm.checkcode = ''
      this.loading = false
      this.createCode()
      this.getUserInfo()
      if (this.codeTimer) {
        clearInterval(this.codeTimer)
        this.codeTimer = null
        this.secondsText = '获取验证码'
      }
    })
  },
  methods: {
    // 输入框获取焦点
    handlefocus (type) {
      if (type === 'user') {
        this.userFocusStatus = true
      }
      if (type === 'check') {
        this.checkFocusStatus = true
      }
      if (this.isShowUserList) {
        this.isShowUserList = false
      }
      this.hasClass = '0'
    },
    // 输入框失去焦点
    handleblur (type) {
      if (type === 'user') {
        this.userFocusStatus = false
      }
      if (type === 'check') {
        this.checkFocusStatus = false
      }
    },
    handleChange () {
      this.userError = false
    },
    // 登录
    handleLogin () {
      if (!phoneReg.test(this.loginForm.username)) {
        this.userError = true
        this.userErrorInfo = '请输入正确的手机号'
        return
      }
      if (!this.loginForm.checkcode) {
        this.codeError = true
        this.codeErrorInfo = '请输入验证码'
        return
      }

      let param = this.loginForm
      // loginType=sms 手机号登录
      param.loginType = 'sms'
      this.loading = true
      this.$store.dispatch('loginOtp', param).then((res) => {
        if (res.errorNo === '0') {
          // 重新登录，获取导航的值，设置false，判断重新获取
          this.$store.commit('SET_DET_MENU', false)
          this.$store.dispatch('getUserImage', '')
          this.$myIpcSend.ipcSender(this.$router, 'open-main-win', '', '/uc-index')

          // 登录成功，记住用户名、密码
          this.updateUserInfo()
          return
        }
        this.codeErrorInfo = res.errorInfo
        this.codeError = true
        this.loading = false
      }).catch(e => {
        console.error(e)
        this.loading = false
      })
    },
    // 获取手机验证码
    async createCode () {
      const _this = this
      if (_this.codeTimer) return
      if (!phoneReg.test(this.loginForm.username)) {
        this.userError = true
        this.userErrorInfo = '请输入正确的手机号'
        return
      }
      // 获取验证码
      _this.codeCount = await this.getCode()

      // 发送成功-倒计时
      _this.codeTimer = setInterval(() => {
        if (_this.codeCount === 0) {
          clearInterval(_this.codeTimer)
          _this.codeCount = 60
          _this.codeTimer = null
          _this.secondsText = '获取验证码'
        } else {
          _this.secondsText = `${_this.codeCount}s后重新获取`
          _this.codeCount--
        }
      }, 1000)
    },
    // 调用接口获取验证码
    getCode () {
      const _this = this
      return new Promise((resolve, reject) => {
        let params = {
          type: 'login',
          account: '',
          userId: '',
          cellPhone: _this.loginForm.username
        }
        sendPhoneCode(params).then(res => {
          if (res.data.success) {
            if (res.data.newUser) {
              _this.userError = true
              _this.userErrorInfo = '该手机号未注册'
              return
            }
            this.$hMessage.success('验证码发送成功')
            resolve(res.data.gmtExpired || 60)
          } else {
            this.$hMessage.warning(res.data.errorInfo)
          }
        }).catch(e => {
          console.error(e.message)
        })
      })
    },
    // 登录后的用户手机号-保存本地
    updateUserInfo () {
      for (let i = 0; i < this.userList.length; i++) {
        if (this.userList[i].user === this.loginForm.username) {
          this.userList.splice(i, 1)
          break
        }
      }
      // 如果遍历没有查到，记住密码的话，则添加
      if (this.remUser) {
        this.userList.push({ user: this.loginForm.username, time: this.currentTime() })
      }
      this.$localStore.set('userlistPhone', this.userList)
      this.$localStore.set('remUser', this.remUser)
      this.$localStore.set('proUser', this.proUser)
    },
    // 获取记住账号的手机号
    getUserInfo () {
      let userinfo = this.$localStore.get('userlistPhone')
      if (typeof (userinfo) !== 'undefined') {
        var arr = new Array(userinfo.length) // 存储时间值
        var timeList = []
        this.userList = []
        for (let k = 0; k < userinfo.length; k++) {
          arr[k] = userinfo[k].time
        }
        timeList = arr.sort().reverse()
        for (let i = 0; i < timeList.length; i++) {
          for (let j = 0; j < userinfo.length; j++) {
            if (timeList[i] === userinfo[j].time) {
              if (i === 0) {
                this.loginForm.username = userinfo[j].user
              }
              this.userList.push({ user: userinfo[j].user, time: userinfo[j].time })
            }
          }
        }
        this.remUser = this.$localStore.get('remUser')
        this.proUser = this.$localStore.get('proUser')
        if (this.proUser) {
          this.setas = 'password'
        } else {
          this.setas = 'text'
        }
      } else {
        this.$localStore.set('userlistPhone', this.userList)
        this.$localStore.set('remUser', this.remUser)
        this.$localStore.set('proUser', this.proUser)
      }
    },
    showAccountList (e) {
      this.isShowUserList = !this.isShowUserList
      if (this.isShowUserList) {
        this.hasClass = '1'
        var info = this.$refs.loginUl
        if (this.userList.length > 5) {
          info.style = 'overflow-y: scroll;height:110px;'
        } else {
          info.style = 'overflow-y: hidden;height:auto;'
        }
      } else {
        this.hasClass = '0'
      }
    },
    handleEnter (type) {
      switch (type) {
        case 'user':
          this.$refs.check2.focus()
          break
        case 'check':
          this.handleLogin()
          break
      }
    },
    changeUser (data) {
      if (this.deleteUserState) {
        this.deleteUserState = false
        return
      }
      this.loginForm.username = data.user
      this.cityList.map(item => {
        item.selected = false
        if (item.value === data.value) {
          item.selected = true
        }
      })
      this.hasClass = '0'
      this.isShowUserList = false
    },
    // 删除用户
    deleteUser (event) {
      this.deleteUserState = true
      for (let i = 0; i < this.userList.length; i++) {
        if (this.userList[i].user === event) {
          if (this.loginForm.username === event) {
            this.loginForm.username = ''
          }
          this.userList.splice(i, 1)
          break
        }
      }
      this.$localStore.set('userlist', this.userList)
    },
    remember () {
      if (this.remUser) {
        this.remUser = false
      } else {
        this.remUser = true
      }
    },
    protect () {
      if (this.proUser) {
        this.setas = 'text'
        this.proUser = false
      } else {
        this.setas = 'password'
        this.proUser = true
      }
    },
    currentTime () {
      let date = new Date()
      var y = date.getFullYear()
      var m = date.getMonth() + 1
      m = m < 10 ? ('0' + m) : m
      var d = date.getDate()
      d = d < 10 ? ('0' + d) : d
      var h = date.getHours()
      h = h < 10 ? ('0' + h) : h
      var minute = date.getMinutes()
      minute = minute < 10 ? ('0' + minute) : minute
      var second = date.getSeconds()
      second = second < 10 ? ('0' + second) : second
      return '' + y + m + d + h + minute + second
    },
  },
  beforeDestroy () {
    if (this.codeTimer) {
      clearInterval(this.codeTimer)
      this.codeTimer = null
    }
  },
}
</script>
<style lang="scss" scoped>
.login-form-wrapper {
  .checkcode {
    cursor: pointer;
    height: 30px !important;
    line-height: 30px;
    color: #298dff;
    width: 88px !important;
    top: 0 !important;
    right: 5px !important;
    text-align: right;
    .has-send-code {
      color: #999;
      cursor: text;
    }
  }
}
.inputimg {
  z-index: 999;
  position: absolute;
  top: 8px;
  right: 30px;
  width: 0px;
  height: 8px;
  border-radius: 4px;
  margin-left: 0px;
}
.form-item-set {
  margin-top: -9px;
  margin-left: -64px;
}
.form-item-set input {
  vertical-align: middle;
  margin-top: -3px;
  margin-right: 4px;
}
ul {
  width: 178px;
  background-color: transparent;
  /* border-radius: 4px; */
  border: 1px solid #fff;
  list-style: none;
  padding: 0;
  margin-top: -12px;
  position: absolute;
  -webkit-app-region: no-drag;
  margin-left: -1px;
  z-index: 10000 !important;
  /* height: 110px; */
  /* overflow-y: scroll; */
}
li {
  height: 21px;
  width: 100%;
  padding: 0 12px;
  text-align: left;
  /* margin-left: -12px; */
  line-height: 18px;
  box-sizing: border-box;
  cursor: pointer;
  background-color: #71797c;
  border-bottom-style: solid;
  border-bottom-width: 1px;
}
li img {
  width: 16px;
  height: 16px;
  float: right;
  margin-top: 2px;
}
li:hover {
  background-color: #d1dadd;
  color: #25687e;
}
li:hover img {
  background: url(../../assets/close1.svg) no-repeat;
}
li:hover img:hover {
  background: url(../../assets/close2.svg) no-repeat;
}
li.selected {
  background-color: white;
  color: #25687e;
}
/* 展开： */
.openlist {
  -webkit-animation: open 0.3s linear forwards;
  animation: open 0.3s linear forwards;
  -webkit-app-region: no-drag;
}
/* 收起： */
.foldlist {
  -webkit-animation: fold 0.3s linear forwards;
  animation: fold 0.3s linear forwards;
  -webkit-app-region: no-drag;
}
</style>
